// extracted by mini-css-extract-plugin
module.exports = {"home-section":"HomeSectionHeader_home-section__uHswW","header":"HomeSectionHeader_header__1kYwd","more-btn":"HomeSectionHeader_more-btn__1-vEJ"};